import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";

import OperatorListComponent from "../components/operator/OperatorListComponent";
import OperatorFormComponent from "../components/operator/OperatorFormComponent";
import OperatorShowComponent from "../components/operator/OperatorShowComponent";
import HelpComponent from "../components/HelpComponent";

const OperatorPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id,action, entity} = useParams();

  useEffect(() => {
    document.title = t('operators') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/operator')
  }, []);

  return (
    <div className="OperatorPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/operator"}/>
      <Panel>
        <OperatorListComponent />
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <OperatorFormComponent />
      </Sidebar>
      <Sidebar position="right" visible={!entity && action === 'read'} closeOnEscape={true}
               style={{width: '780px'}}
               onHide={() => {
                 navigate(-1)
               }}>
        <OperatorShowComponent />
      </Sidebar>
    </div>
  )
}
export default withTranslation('common')(OperatorPage);
